import React, { useState } from "react";
import { Check, Loader2, X } from "lucide-react";

interface ConfirmActionButtonProps {
  onConfirm: () => void;
  children: React.ReactNode;
  confirmText?: string;
  cancelText?: string;
  className?: string;
  confirmClassName?: string;
  cancelClassName?: string;
  isLoading?: boolean;
}

const ConfirmActionButton: React.FC<ConfirmActionButtonProps> = ({
  onConfirm,
  children,
  confirmText = "Confirm",
  cancelText = "Cancel",
  className = "",
  confirmClassName = "",
  cancelClassName = "",
  isLoading = false,
}) => {
  const [isExpanded, setIsExpanded] = useState(false);

  const handleInitialClick = () => {
    setIsExpanded(true);
  };

  const handleCancel = () => {
    setIsExpanded(false);
  };

  const handleConfirm = () => {
    onConfirm();
    setIsExpanded(false);
  };

  if (!isExpanded) {
    return (
      <button
        onClick={handleInitialClick}
        className={`flex shrink-0 items-center gap-1 rounded-md px-2 py-1 text-xs whitespace-nowrap transition-colors duration-150 ${className || "text-soluud-text-secondary bg-gray-100 hover:bg-gray-200"}`}
      >
        {children}
      </button>
    );
  }

  return (
    <div className="flex items-center gap-1">
      <button
        onClick={handleCancel}
        className={`flex shrink-0 items-center gap-1 rounded-md px-2 py-1 text-xs whitespace-nowrap transition-colors duration-150 ${cancelClassName || "text-soluud-text-secondary bg-gray-100 hover:bg-gray-200"}`}
      >
        <X className="h-3 w-3" />
        {cancelText}
      </button>
      <button
        onClick={handleConfirm}
        className={`flex shrink-0 items-center gap-1 rounded-md px-2 py-1 text-xs whitespace-nowrap transition-colors duration-150 ${confirmClassName || "bg-soluud-warning text-white hover:bg-red-600"}`}
      >
        {isLoading ? (
          <Loader2 className="h-3 w-3 animate-spin" />
        ) : (
          <Check className="h-3 w-3" />
        )}
        {confirmText}
      </button>
    </div>
  );
};

export default ConfirmActionButton;
